<template>
  <div>
    <v-card class="pb-4">
      <v-card-title class="subtitle-1 font-weight-bold"
        >{{ $vuetify.lang.t("$vuetify.payment.list.title", [getTitle()]) }}
      </v-card-title>
      <v-divider></v-divider>
      <div class="mt-5 mx-5">
        <v-btn
          :loading="loading.refresh"
          @click="refreshItems()"
          class="mr-2 my-2"
          depressed
        >
          <v-icon color="primary" left>mdi-refresh</v-icon>
          {{ $vuetify.lang.t("$vuetify.btn.refresh") }}
        </v-btn>
        <v-btn @click="showFilter()" class="mr-2 my-2" depressed>
          <v-icon color="primary" left>mdi-filter-outline</v-icon>
          {{ $vuetify.lang.t("$vuetify.payment.btn.filter.title") }}
        </v-btn>
        <v-btn
          :loading="isDownload.default"
          @click="download()"
          class="mr-2 my-2"
          depressed
        >
          <v-icon color="primary" left>mdi-file-excel-outline</v-icon>
          {{ $vuetify.lang.t("$vuetify.payment.btn.excelFile.title") }}
        </v-btn>
      </div>
      <v-data-table
        :footer-props="{
          'items-per-page-options': itemPerPageOptions
        }"
        :headers="headers"
        :items="items"
        :items-per-page="itemPerPage"
        :loading="loading.list"
        :options.sync="pagination"
        :server-items-length="meta.total"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        class="mt-5"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              :key="item.id"
              @mouseleave="unSelectItem()"
              @mouseover="selectItem(item)"
              v-for="item in items"
            >
              <td class="subtitle-2">
                {{ $moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
              </td>
              <!--            <td class="subtitle-2">{{ item.invoiceId }}</td>-->
              <td
                class="subtitle-2"
                v-if="
                  $auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])
                "
              >
                {{ item.application.user.username }}
              </td>
              <td class="subtitle-2" v-else>{{ item.application.name }}</td>
              <td class="subtitle-2">
                <v-chip
                  class="chip-list"
                  color="teal accent-4"
                  text-color="white"
                  >{{ item.amount }}</v-chip
                >
              </td>
              <td class="subtitle-2">
                <v-chip
                  class="chip-list"
                  color="teal accent-4"
                  text-color="white"
                  >{{ item.charges }}</v-chip
                >
              </td>
              <td class="subtitle-2">
                <v-chip
                  :color="getTypeColor(item.type)"
                  class="chip-list"
                  text-color="white"
                  >{{ item.type }}</v-chip
                >
              </td>
              <td class="subtitle-2">
                <v-chip
                  :color="getStatusColor(item.status)"
                  class="chip-list"
                  text-color="white"
                  v-if="item.status"
                  >{{
                    $vuetify.lang.t("$vuetify.paymentStatus." + item.status)
                  }}
                </v-chip>
              </td>
              <td class="subtitle-2">{{ item.accountNumber }}</td>
              <td class="subtitle-2">
                <template v-if="item === selectedItem">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click="viewPayment(item)"
                        color="primary"
                        icon
                        small
                        text
                        v-on="on"
                      >
                        <v-icon>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t("$vuetify.payment.btn.view.title")
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top v-if="item.status === 'SUCCESS'">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :loading="isDownload.bill"
                        @click="download('bill', item)"
                        color="primary"
                        icon
                        small
                        text
                        v-on="on"
                      >
                        <v-icon>mdi-cloud-print-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t("$vuetify.payment.btn.print.title")
                    }}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMPTA'])"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click="showChangeStatus(item)"
                        color="primary"
                        icon
                        small
                        text
                        v-on="on"
                      >
                        <v-icon>mdi-diameter-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.t("$vuetify.payment.btn.changeStatus.title")
                    }}</span>
                  </v-tooltip>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <filter-form
      :dialog="dialogForm"
      :filter="filter"
      @performFilter="performFilter"
      ref="filterForm"
    ></filter-form>
    <detail-form
      :dialog="dialogForm"
      :form="form"
      ref="detailForm"
    ></detail-form>
    <change-status-form
      :dialog="dialogForm"
      :form="form"
      @getItems="getItems"
      ref="changeStatusForm"
    ></change-status-form>
  </div>
</template>

<script>
import ListMixin from "./../../mixins/Common/List.vue";
import FilterForm from "./Filter";
import DetailForm from "./Form";
import ChangeStatusForm from "./ChangeStatus";
import Utils from "../../helpers/Utils";
import URLPath from "../../helpers/URL";

export default {
  mixins: [ListMixin],
  data: () => ({
    urlItems: "/payments",
    sortBy: ["p_id"],
    dialogForm: {
      title: "$vuetify.payment.btn.filter.title",
      shows: {
        showFilter: false,
        showDetail: false,
        showChangeStatus: false
      },
      saveBtnTitle: "$vuetify.btn.save",
      action: "create"
    },
    form: {
      identifier: null,
      remoteIdentifier: null,
      application: null,
      accountNumber: null,
      invoiceId: null,
      amount: null,
      reference: null,
      remoteReference: null,
      transaction: null,
      operation: null,
      status: null,
      expiredAt: null,
      createdAt: null
    },
    filter: {
      application: null,
      accountNumber: null,
      reference: null,
      remoteReference: null,
      invoiceId: null,
      status: null,
      user: null,
      identifier: null,
      remoteIdentifier: null,
      transaction: null,
      createdAt: {
        start: null,
        end: null
      }
    },
    isDownload: {
      default: false,
      bill: false
    },
    application: {}
  }),
  watch: {
    "filter.createdAt.start": function(date) {
      if (date) {
        date = Utils.restrictDate(date);
        this.filter.createdAt.end = date.toISOString().substr(0, 10);
      }
    }
  },
  created() {
    if (this.$route.query.applicationId && this.$route.query.applicationName) {
      this.filter.application = this.$route.query.applicationId;
      this._search = this.buildSearchQuery();
    } else if (this.$route.params.invoiceId) {
      this.filter.invoiceId = this.$route.params.invoiceId;
      this._search = this.buildSearchQuery();
    } else if (this.$route.query.transactionId) {
      if (this.$cookies.isKey(Utils.getTesterCookieName())) {
        let data = this.$cookies.get(Utils.getTesterCookieName());
        this.filter.invoiceId = data.invoiceId;
        this.$cookies.remove(Utils.getTesterCookieName());
        this._search = this.buildSearchQuery();
        this.getPayment();
      }
    }
  },
  methods: {
    setHeaders() {
      this.headers = [
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.created.title"),
          value: "p_createdAt",
          align: "start",
          sortable: true,
          width: "140",
          class: "grey--text text--darken-3"
        }
      ];
      if (this.$auth.check(["ROLE_ADMIN", "ROLE_COMMERCIAL", "ROLE_COMPTA"]))
        this.headers.push({
          text: this.$vuetify.lang.t("$vuetify.payment.cols.user.title"),
          value: "p_user",
          align: "start",
          sortable: false,
          width: "150",
          class: "grey--text text--darken-3"
        });
      else
        this.headers.push({
          text: this.$vuetify.lang.t("$vuetify.payment.cols.application.title"),
          value: "p_application",
          align: "start",
          sortable: false,
          width: "150",
          class: "grey--text text--darken-3"
        });
      const headers = [
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.amount.title"),
          value: "p_amount",
          align: "start",
          sortable: true,
          width: "120",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.charges.title"),
          value: "p_charges",
          align: "start",
          sortable: false,
          width: "90",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.transaction.title"),
          value: "p_type",
          align: "start",
          sortable: false,
          width: "90",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.status.title"),
          value: "p_status",
          align: "start",
          sortable: true,
          width: "100",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t(
            "$vuetify.payment.cols.accountNumber.title"
          ),
          value: "p_accountNumber",
          align: "start",
          sortable: false,
          width: "130",
          class: "grey--text text--darken-3"
        },
        {
          text: this.$vuetify.lang.t("$vuetify.payment.cols.action.title"),
          value: null,
          sortable: false,
          width: "110"
        }
      ];
      this.headers = this.headers.concat(headers);
    },
    getPayment() {
      this.getItems().then(response => {
        let items = response.data.items;
        if (!this._.isEmpty(items)) {
          this.viewPayment(items[0]);
        }
      });
    },
    buildSearchQuery() {
      let query = "";
      if (this.filter.application)
        query = "p_applicationId::eq::" + this.filter.application;
      if (this.filter.user) query = "a_userId::eq::" + this.filter.user;
      if (this.filter.accountNumber) {
        if (this._.isEmpty(query))
          query = "p_accountNumber::eq::" + this.filter.accountNumber;
        else query += ",p_accountNumber::eq::" + this.filter.accountNumber;
      }
      if (this.filter.invoiceId) {
        if (this._.isEmpty(query))
          query = "p_invoiceId::eq::" + this.filter.invoiceId;
        else query += ",p_invoiceId::eq::" + this.filter.invoiceId;
      }
      if (this.filter.status) {
        if (this._.isEmpty(query))
          query = "p_status::eq::" + this.filter.status;
        else query += ",p_status::eq::" + this.filter.status;
      }
      if (this.filter.transaction) {
        if (this._.isEmpty(query))
          query = "p_type::eq::" + this.filter.transaction;
        else query += ",p_type::eq::" + this.filter.transaction;
      }
      if (this.filter.reference) {
        if (this._.isEmpty(query))
          query = "p_reference::eq::" + this.filter.reference;
        else query += ",p_reference::eq::" + this.filter.reference;
      }
      if (this.filter.remoteReference) {
        if (this._.isEmpty(query))
          query = "p_remoteReference::eq::" + this.filter.remoteReference;
        else query += ",p_remoteReference::eq::" + this.filter.remoteReference;
      }
      if (this.filter.identifier) {
        if (this._.isEmpty(query))
          query = "p_identifier::eq::" + this.filter.identifier;
        else query += ",p_identifier::eq::" + this.filter.identifier;
      }
      if (this.filter.remoteIdentifier) {
        if (this._.isEmpty(query))
          query = "p_remoteIdentifier::eq::" + this.filter.remoteIdentifier;
        else
          query += ",p_remoteIdentifier::eq::" + this.filter.remoteIdentifier;
      }
      if (this.filter.createdAt.start) {
        if (this._.isEmpty(query)) {
          query =
            "p_createdAt::lte::" +
            this.$moment(this.filter.createdAt.end)
              .endOf("day")
              .format("x");
          query +=
            ",p_createdAt::gte::" +
            this.$moment(this.filter.createdAt.start)
              .startOf("day")
              .format("x");
        } else {
          query +=
            ",p_createdAt::lte::" +
            this.$moment(this.filter.createdAt.end)
              .endOf("day")
              .format("x");
          query +=
            ",p_createdAt::gte::" +
            this.$moment(this.filter.createdAt.start)
              .startOf("day")
              .format("x");
        }
      }
      if (this._.isEmpty(query)) query = null;
      return query;
    },
    showFilter() {
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.payment.filter.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t(
        "$vuetify.payment.btn.filter.title"
      );
      this.dialogForm.shows.showFilter = true;
    },
    viewPayment(item) {
      this.$refs.detailForm.setPayment(item);
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.payment.view.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t(
        "$vuetify.payment.btn.filter.title"
      );
      this.dialogForm.shows.showDetail = true;
    },
    showChangeStatus(item) {
      this.$refs.changeStatusForm.setForm(item);
      this.dialogForm.title = this.$vuetify.lang.t(
        "$vuetify.payment.changeStatus.title"
      );
      this.dialogForm.saveBtnTitle = this.$vuetify.lang.t("$vuetify.btn.save");
      this.dialogForm.shows.showChangeStatus = true;
    },
    performFilter() {
      this._search = this.buildSearchQuery();
      let self = this;
      this.getItems()
        .then(() => {
          this.$refs.filterForm.closeDialog();
        })
        .finally(() => {
          self.$refs.filterForm.stopLoadingBtn();
        });
    },
    getTypeColor(type) {
      switch (type) {
        case "OM":
          return "orange darken-1";
        case "MOMO":
          return "yellow darken-2";
        case "EUM":
          return "blue darken-2";
        default:
          return "secondary";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "NEW":
          return "primary";
        case "PENDING":
          return "purple";
        case "ERROR":
          return "red darken-4";
        case "CANCEL":
          return "red darken-1";
        case "TIMEOUT":
          return "pink darken-1";
        case "SUCCESS":
          return "teal accent-4";
        default:
          return "primary";
      }
    },
    cantDonwload() {
      if (this.filter.createdAt.start) {
        return true;
      } else {
        this.$store.dispatch("setNotification", {
          status: true,
          message: this.$vuetify.lang.t(
            "$vuetify.payment.btn.excelFile.message"
          )
        });
        return false;
      }
    },
    download(action = "default", item = null) {
      let data = {};
      if (action === "bill") {
        data = {
          url: URLPath.PAYMENT.DOWNLOAD.PROCESS.URI,
          method: URLPath.PAYMENT.DOWNLOAD.PROCESS.METHOD,
          responseType: "blob",
          data: {
            search: item.invoiceId
          }
        };
        this.getDownload(data);
      } else if (this.cantDonwload()) {
        let query = this.buildSearchQuery();
        this.isDownload.default = true;
        data = {
          url: URLPath.PAYMENT.DOWNLOAD.URI,
          method: URLPath.PAYMENT.DOWNLOAD.METHOD,
          responseType: "blob",
          params: {
            _search: query,
            "_sorts[p_createdAt]": "DESC"
          }
        };
        this.getDownload(data);
      } else {
        this.showFilter();
      }
    },
    getDownload(data) {
      let self = this;
      this.$store
        .dispatch("request", data)
        .then(response => {
          let contentDisposition = response.request.getResponseHeader(
            "Content-Disposition"
          );
          let fileName = "Payment";
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }
          let blob = new Blob([response.data], { type: response.data.type });
          Utils.saveAsFile(blob, fileName);
        })
        .catch(() => {
          self.$store.dispatch("setNotification", {
            status: true,
            message: this.$vuetify.lang.t("$vuetify.error_occured")
          });
        })
        .finally(() => {
          self.isDownload.default = false;
          self.isDownload.bill = false;
        });
    },
    getTitle() {
      if (!this._.isEmpty(this.$route.query.applicationName))
        return this.$route.query.applicationName;
      return "";
    }
  },
  components: {
    DetailForm,
    FilterForm,
    ChangeStatusForm
  }
};
</script>

<style scoped></style>
